import styled from 'styled-components';
import { Paper, DataTable, theme, minBp } from '@triumph/shared';

export const Wrap = styled(Paper)`
  padding: 30px 20px 20px;
  margin-bottom: 24px;
  position: relative;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 27px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    padding-bottom: 30px;
    margin-bottom: 40px;
  }
`;

export const EditButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  color: ${theme.colors.primary};
  font-size: 16px;
  font-family: inherit;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  right: 20px;

  @media ${minBp('desktop')} {
    top: 43px;
    right: 62px;
  }
`;

export const DetailsWrap = styled.div`
  margin: 0 0 20px;
  border-bottom: 1px solid ${theme.colors.hairline};

  @media ${minBp('tabletLarge')} {
    display: flex;
  }
`;

export const Summary = styled.div`
  font-size: 13px;
  line-height: 22px;
  margin: 0 0 24px;

  @media ${minBp('desktop')} {
    font-size: 14px;
    margin: 0 0 43px;
  }
`;

export const Table = styled(DataTable)`
  margin-bottom: 27px;

  @media ${minBp('tabletLarge')} {
    max-width: 400px;
    flex: 1;
    margin-bottom: 50px;
    margin-right: 58px;
  }
`;

export const CollectionGuidance = styled.div`
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 22px;

  @media ${minBp('tabletLarge')} {
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 24px;
  }
`;
